import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import MainTemplate from "../../mainTemplate";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextField from "canvas-core-react/lib/TextField";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import useApi from "../../../hooks/useApi";
import { EXECUTE, MOD_PROVID } from "../../../../permissions/index";
import { getRoles } from "../../../../Redux/reducer/session";
import { useSelector } from "react-redux";
import Modal from "../../../utils/customModal";

import {
  loadingHtml,
  moduleAction,
  sucessInfoModal,
} from "../../../utils/functions";
import { LABELS_ACCOUNT_TYPE } from "../../../shared/AccountTypeSelect";

export const format = (data) => {
  let detail = (
    <>
      <p>Se presentaron los siguientes errores:</p>
      <ul>
        {data.details.map(({ message }, key) => (
          <li key={`res-${key}`}>{message}</li>
        ))}
      </ul>
    </>
  );

  if (data.totalLines === data.totalLinesOk) {
    detail = <p>La operación fue realizada con éxito.</p>;
  }

  return detail;
};

const AdmisionDetail = () => {
  const { t } = useTranslation();
  const roles = useSelector((state) => getRoles(state));
  const { getApiCAll, cancellCall, postApiCAll } = useApi();
  const { companyId, requestType, currency } = useParams();
  const history = useHistory();

  const [data, setData] = useState({});
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
    return () => cancellCall();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await getApiCAll(
        `/providers/addition-account-detail/company/${companyId}/${requestType}/${currency}`
      );

      const data = response.data.data;
      setData(data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      let button = {
        formBtn: {
          text: "Cerrar",
          action: () => {
            setModal({
              show: false,
              ontent: null,
              onClose: undefined,
            });
          },
        },
      };
      let content = sucessInfoModal(
        "Adiciones/Modificaciones",
        "Ha ocurrido un error inesperado, favor intente mas tarde",
        button
      );
      setModal({
        show: true,
        content,
        onClose: () => history.replace("/providers"),
      });
    }
  };

  const doApproveOrReject = (data) => {
    setLoading(true);

    return postApiCAll(
      `providers/additions-modifications-accouts-csa/approve-or-rejected`,
      data,
      {}
    )
      .then((response) => {
        setLoading(false);
        getModalResponse(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAction = (flag, response) => {
    let data = [];
    data.push({ approve: flag, id: response.provider?.modifyAccount[0]?.id });
    doApproveOrReject(data);
  };

  const getModalResponse = (data) => {
    let button = { formBtn: { text: "Continuar", action: closeAndReset } };
    let content = sucessInfoModal(
      "Adiciones/Modificaciones",
      format(data.data),
      button
    );
    setModal({ show: true, content, onClose: closeAndReset });
  };

  const closeAndReset = () => {
    closeModal();
    history.push("/admissions");
  };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const currencyStyle = {
    marginTop: "20px",
  };

  const getProfile = () => {
    return data.provider?.modifyAccount[0].accountId === null
      ? newAccount()
      : modifyAccount();
  };

  const newAccount = () => {
    return (
      <>
        <Column lg={5} md={5}>
          <TextField
            id="accountType"
            label={t("providers.detail.accountType")}
            value={
              LABELS_ACCOUNT_TYPE[
                data.provider?.modifyAccount[0]?.accountType
              ] || "No aplica"
            }
            disabled={true}
          />
        </Column>
        <Column lg={5} md={5}>
          <TextField
            id="bicDestinationBank"
            label={t("providers.detail.bicDestinationBank")}
            value={
              data.provider?.modifyAccount[0]?.bicDestinationBank || "No aplica"
            }
            disabled={true}
          />
        </Column>

        <Column lg={5} md={5}>
          <TextField
            id="accountNumber"
            label={t("providers.detail.accountNumber")}
            value={
              data.provider?.modifyAccount[0]?.accountNumber || "No aplica"
            }
            disabled={true}
          />
        </Column>
        <Column lg={5} md={5}>
          <TextField
            id="bicIntermediaryBank"
            label={t("providers.detail.bicIntermediaryBank")}
            value={
              data.provider?.modifyAccount[0]?.bicIntermediaryBank ||
              "No aplica"
            }
            disabled={true}
          />
        </Column>

        <Column lg={5} md={5}>
          <TextField
            id="bicAccountIntermediaryBank"
            label={t("providers.detail.bicAccountIntermediaryBank")}
            value={
              data.provider?.modifyAccount[0]?.bicAccountIntermediaryBank ||
              "No aplica"
            }
            disabled={true}
          />
        </Column>
        <Column lg={5} md={5}>
          <TextField
            id="currency"
            label={t("providers.detail.currency")}
            value={data.provider?.modifyAccount[0]?.currency || "No aplica"}
            disabled={true}
          />
        </Column>
      </>
    );
  };

  const modifyAccount = () => {
    return (
      <>
        <Column lg={6} md={6}>
          <Row nested>
            <Column lg={6}>
              <TextField
                id="accountTypeCurrent"
                label="Tipo de Cuenta Actual"
                name="accountTypeCurrent"
                disabled={true}
                value={
                  LABELS_ACCOUNT_TYPE[data.provider?.accounts[0]?.accountType] ||
                  "No aplica"
                }
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountType"
                label="Tipo de Cuenta Nueva"
                name="accountType"
                disabled={true}
                value={
                  LABELS_ACCOUNT_TYPE[
                    data.provider?.modifyAccount[0].accountType
                  ] || "No aplica"
                }
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountNumberCurrent"
                name="accountNumberCurrent"
                label="Número de Cuenta Actual"
                value={data.provider?.accounts[0]?.accountNumber || "No aplica"}
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountNumber"
                label="Número de Cuenta Nueva"
                name="accountNumber"
                value={
                  data.provider?.modifyAccount[0].accountNumber || "No aplica"
                }
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountIntermediaryBankCurrent"
                name="accountIntermediaryBankCurrent"
                label={"Cuenta Banco Destino\ncon Intermediario Actual"}
                value={
                  data.provider?.accounts[0]?.accountIntermediaryBank ||
                  "No aplica"
                }
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountIntermediaryBank"
                name="accountIntermediaryBank"
                label={"Cuenta Banco Destino\ncon Intermediario Nueva"}
                value={
                  data.provider?.modifyAccount[0].accountIntermediaryBank ||
                  "No aplica"
                }
                disabled={true}
              />
            </Column>
          </Row>
        </Column>
        <Column lg={6} md={6}>
          <Row nested>
            <Column lg={6}>
              <TextField
                id="bicDestinationBankCurrent"
                name="bicDestinationBankCurrent"
                label="Bic Banco Destino Actual"
                value={
                  data.provider?.accounts[0]?.bicDestinationBank || "No aplica"
                }
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="bicDestinationBank"
                name="bicDestinationBank"
                label="Bic Banco Destino Nueva"
                value={
                  data.provider?.modifyAccount[0].bicDestinationBank ||
                  "No aplica"
                }
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="bicIntermediaryBankCurrent"
                name="bicIntermediaryBankCurrent"
                label="Bic Banco Intermediario Actual"
                value={
                  data.provider?.accounts[0]?.bicIntermediaryBank || "No aplica"
                }
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="bicIntermediaryBank"
                name="bicIntermediaryBank"
                label="Bic Banco Intermediario Nueva"
                value={
                  data.provider?.modifyAccount[0].bicIntermediaryBank ||
                  "No aplica"
                }
                disabled={true}
              />
            </Column>
            <Column lg={6}>
              <TextField
                id="accountCurrencyCurrent"
                name="accountCurrencyCurrent"
                style={currencyStyle}
                label="Moneda"
                value={
                  data.provider?.accounts[0]?.accountCurrency || "No aplica"
                }
                disabled={true}
              />
            </Column>
          </Row>
        </Column>
      </>
    );
  };

  return (
    <>
      <MainTemplate className="">
        <div className="profile">
          <h3>{t("providers.detail.generalInformation")}</h3>
          <Grid fluid={true}>
            <Row className="spacing-column" justifyContent="spaceBetween">
              <Column lg={5} md={5}>
                <TextField
                  id="name"
                  label={t("providers.manual.form.name.label")}
                  value={data.companyName || ""}
                  disabled={true}
                />
              </Column>
              <Column lg={5} md={5}>
                <TextField
                  id="id"
                  label={t("providers.manual.form.id.label")}
                  value={data.businessId || ""}
                  disabled={true}
                />
              </Column>
            </Row>
            <Row justifyContent="spaceBetween">
              <Column lg={5} md={5}>
                <TextField
                  id="requestType"
                  label={t("providers.detail.requestType")}
                  value={t(
                    `general.relationTypes_detail.${data.provider?.requestType}` ||
                      ""
                  )}
                  disabled={true}
                />
              </Column>
              <Column lg={5} md={5}>
                <TextField
                  id="statusRequest"
                  label={t("providers.detail.statusRequest")}
                  value={t(
                    `general.inviteStates.${data.provider?.invitationStatus}` ||
                      ""
                  )}
                  disabled={true}
                />
              </Column>
            </Row>
          </Grid>
          <h3>{t("providers.detail.titleAccountSettlement")}</h3>
          <Grid fluid={true}>
            <Row className="spacing-column" justifyContent="spaceBetween">
              {getProfile()}
            </Row>
          </Grid>

          <div className="form-actions clearfix">
            <SecondaryButton onClick={() => history.push("/admissions")}>
              Atrás
            </SecondaryButton>
            {moduleAction(roles, MOD_PROVID, EXECUTE) ? (
              <>
                <SecondaryButton onClick={() => getAction(false, data)}>
                  Rechazar
                </SecondaryButton>
                <SecondaryButton onClick={() => getAction(true, data)}>
                  Aprobar
                </SecondaryButton>
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      </MainTemplate>
      <Modal show={loading}>{loadingHtml()}</Modal>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </>
  );
};
export default AdmisionDetail;
